/**
 * Font warm-up (S4-03 part 6): the first layout that uses a web font face pays for decoding and shaping set-up — the
 * HUD's first layout took 50 ms at 4× CPU for 82 layout objects, most of it the mono faces. Loaded while the data
 * loads and laid out once off screen, one face per task, so the HUD's own layout stays short.
 */
import { yieldToMain } from '../scene/Scene';

const FACES = ['500 16px "IBM Plex Mono"', '600 16px "IBM Plex Mono"'];

export async function warmFonts(): Promise<void> {
  if (!document.fonts) return;
  await Promise.all(FACES.map((face) => document.fonts.load(face).catch(() => [])));
  for (const face of FACES) {
    await yieldToMain();
    const probe = document.createElement('span');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = `position:absolute;left:-9999px;top:0;visibility:hidden;font:${face}`;
    probe.textContent = '0123456789 −+.,:/ km/s AU UTC ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    document.body.append(probe);
    void probe.offsetWidth;
    probe.remove();
  }
}
